import React, { useEffect,  useRef } from "react";

import { Row, Col } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import FASTable from "../../../../../components/Tables/FASTable";
import {
  Ledgersummary,
  SummaryFun,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Ledger/LedgerSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function Summary({
  accountName,
  accountGroup,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);

  const { Ledgersummarydata } = useSelector((state) => state.LedgerSlice);

  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    dispatch(SummaryFun());

    dispatch(
      Ledgersummary({
        Firm,
        Year: FinancialYear,
        selectedIds: accountGroup,
        AcIDs: accountName,
        startDate: startDate,
        endDate: endDate,
      }),
    );
  }, [accountName, accountGroup]);

  const formatIndianAmount = (value) => {
    if (!value) return "0.00";

    const str = String(value).trim();

    // Number extract
    const numberMatch = str.match(/-?\d+(\.\d+)?/);

    if (!numberMatch) return value;

    const num = Number(numberMatch[0]);

    // Cr / Dr extract
    const typeMatch = str.match(/\b(Cr|Dr)\b/i);
    const type = typeMatch ? typeMatch[0] : "";

    const formattedNumber = num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `${formattedNumber} ${type}`.trim();
  };

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    // ---------------- TITLE ----------------
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");

    doc.text("Ledger Summary Report", pageWidth / 2, 15, {
      align: "center",
    });

    doc.setLineWidth(0.5);
    doc.line(marginX, 18, pageWidth - marginX, 18);

    // ---------------- FIRM NAME ----------------
    const firmName =
      DataMain?.Firm_Dtl?.[0]?.FirmName ||
      DataMain?.Firm_List?.[0]?.GroupName ||
      "";

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");

    doc.text(firmName, pageWidth / 2, 25, {
      align: "center",
    });

    // ================= DATA =================
    const details = Ledgersummarydata?.AccountDetail?.[0] || {};

    const openingAmount = Ledgersummarydata?.AccountDetail?.[0]?.OpAmount || 0;

    const balanceAmount = Ledgersummarydata?.LedgerSumm?.[0]?.Balance || 0;

    let yPos = 35;

    // ================= LEFT SIDE =================
    doc.setFontSize(11);
    doc.setFont(undefined, "normal");

    doc.text(`A/c Name : ${details?.AcName || "-"}`, marginX, yPos);
    yPos += 8;

    doc.text(`Pan No : ${details?.PanNo || "-"}`, marginX, yPos);
    yPos += 8;

    doc.text(`City : ${details?.CityName || "-"}`, marginX, yPos);
    yPos += 8;

    doc.text(`Address : ${details?.Address || "-"}`, marginX, yPos);

    // ================= RIGHT SIDE (FIXED ALIGNMENT) =================
    const rightEdge = pageWidth - marginX;

    doc.setFont("helvetica", "bold");

    const openingText = `Opening : ${formatIndianAmount(openingAmount || 0)}`;

    const balanceText = `Balance : ${formatIndianAmount(balanceAmount || 0)}`;

    doc.text(openingText, rightEdge - doc.getTextWidth(openingText), 50);

    doc.text(balanceText, rightEdge - doc.getTextWidth(balanceText), 57);

    yPos += 14;
    doc.line(marginX, yPos, pageWidth - marginX, yPos);

    // ================= TABLE DATA =================
    const tableRows =
      Ledgersummarydata?.Detail?.map((row, index) => [
        index + 1,
        row?.AgAcName || "-",
        row.GroupMstName || "-",
        formatIndianAmount(row?.Debit || 0),
        formatIndianAmount(row?.Credit || 0),
      ]) || [];
    // ================= TOTAL =================
    const totalDebit =
      Ledgersummarydata?.Detail?.reduce(
        (sum, r) => sum + Number(r?.Debit || 0),
        0,
      ) || 0;

    const totalCredit =
      Ledgersummarydata?.Detail?.reduce(
        (sum, r) => sum + Number(r?.Credit || 0),
        0,
      ) || 0;

    tableRows.push([
      "",
      "",
      "TOTAL",
      formatIndianAmount(totalDebit),
      formatIndianAmount(totalCredit),
    ]);
    // ================= TABLE =================
    autoTable(doc, {
      startY: yPos + 7,

      head: [["Sr No", "Sub Account", "AcGroup Name", "Debit", "Credit"]],

      body: tableRows,

      theme: "grid",

      styles: {
        fontSize: 8,
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
        cellPadding: 2,
        valign: "middle",
        overflow: "linebreak",
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        fontSize: 9,
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 15 },
        1: { halign: "left", cellWidth: "auto" },
        2: { halign: "left", cellWidth: "auto" },
        3: { halign: "right", cellWidth: 35 },
        4: { halign: "right", cellWidth: 35 },
      },

      margin: { left: 10, right: 10 },

      didParseCell: (data) => {
        if (data.row.raw?.[2] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [235, 235, 235];
        }
      },
    });

    // ================= SAVE =================
    doc.save("Ledger_Summary_Report.pdf");
  };

  if (accountName.length === 0) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "100vh",
          fontSize: "20px",
          color:
            isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour10,
        }}
      >
        Please Select Accounts Name
      </div>
    );
  }
  if (Ledgersummarydata === "no" || Ledgersummarydata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  const getRows = Ledgersummarydata?.Detail?.map((label, index) => ({
    // srNumber: index + 1,
    AgAcName: label.AgAcName,
    // Date: formatDateToDDMMYYYY(label.Date),
    // TransactionName: label.TransactionName,
    GroupMstName: label.GroupMstName,
    Debit: label.Debit,
    Credit: label.Credit,
  }));
  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    // { label: "Date", key: "Date", align:"right" },
    {
      label: "SubAccount Name",
      key: "AgAcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "AcGroup Name",
      key: "GroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Debit", key: "Debit", align: "right", format: true },
    { label: "Credit", key: "Credit", align: "right", format: true },
  ];

  return (
    <div style={{ paddingTop: "16px" }}>
      <style>{`
        .common-hover-btn {
          transition: transform 0.25s ease;
          transform: scale(1);
        }
        .common-hover-btn:hover {
          transform: scale(1.01);
        }
        .common-hover-btn:active {
          transform: scale(0.98);
        }
      `}</style>

      <Row>
        <Col xs={12}>
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
              borderRadius: "16px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              padding: "24px",
              border: `2px solid ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7}`,
            }}
          >
            <Row className="g-4 align-items-stretch">
              {/* LEFT CONTENT */}
              <Col xl={6} lg={6} md={12}>
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <Row className="g-3">
                      <Col xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            A/c Name:
                          </span>
                          <span
                            style={{
                              fontSize: "18px",
                              fontWeight: "800",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {Ledgersummarydata?.AccountDetail?.[0]?.AcName ||
                              "-"}
                          </span>
                        </div>
                      </Col>

                      <Col md={6} xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            Pan No:
                          </span>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {Ledgersummarydata?.AccountDetail?.[0]?.PanNo ||
                              "-"}
                          </span>
                        </div>
                      </Col>

                      <Col xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            City:
                          </span>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {Ledgersummarydata?.AccountDetail?.[0]?.CityName ||
                              "-"}
                          </span>
                        </div>
                      </Col>

                      <Col xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "flex-start",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.6",
                            }}
                          >
                            Address:
                          </span>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              lineHeight: "1.6",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                            }}
                          >
                            {Ledgersummarydata?.AccountDetail?.[0]?.Address ||
                              "-"}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-end",
                    }}
                  >
                    <button
                      onClick={handleDownload}
                      className="common-hover-btn"
                      style={{
                        background:
                          isdark === "light"
                            ? iscolour?.Colour6
                            : iscolourDark?.Colour10,
                        color:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour4,
                        border: "none",
                        borderRadius: "10px",
                        padding: "12px 18px",
                        fontWeight: "700",
                        fontSize: "15px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        cursor: "pointer",
                      }}
                    >
                      <FiDownload size={16} />
                      Download PDF
                    </button>
                  </div>
                </div>
              </Col>

              {/* RIGHT SIDE */}
              <Col xl={6} lg={6} md={12}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "100%",
                    gap: "12px",
                  }}
                >
                  {/* BOX 1 */}
                  <div
                    className="common-hover-btn"
                    style={{
                      background:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour2,
                      border: `1px solid ${
                        isdark === "light"
                          ? iscolour?.Colour3
                          : iscolourDark?.Colour10
                      }`,
                      borderLeft: `6px solid ${
                        isdark === "light"
                          ? iscolour?.Colour6
                          : iscolourDark?.Colour10
                      }`,
                      borderRadius: "12px",
                      width: "100%",
                      padding: "25px",
                      height: "100px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "700",
                          minWidth: "95px",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour5
                              : iscolourDark?.Colour12,
                          letterSpacing: "2px",
                        }}
                      >
                        OPENING :
                      </span>

                      <span
                        style={{
                          fontSize: "28px",
                          fontWeight: "800",
                          textAlign: "center",
                          flex: 1,
                          color:
                            isdark === "light"
                              ? iscolour?.Colour12
                              : iscolourDark?.Colour12,
                          lineHeight: "1",
                        }}
                      >
                        {formatIndianAmount(
                          Ledgersummarydata?.AccountDetail?.[0]?.OpAmount || 0,
                        )}
                      </span>

                      <div style={{ minWidth: "95px" }}></div>
                    </div>
                  </div>

                  {/* BOX 2 */}
                  <div
                    className="common-hover-btn"
                    style={{
                      background:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour2,
                      border: `1px solid ${
                        isdark === "light"
                          ? iscolour?.Colour3
                          : iscolourDark?.Colour10
                      }`,
                      borderLeft: `6px solid ${
                        isdark === "light"
                          ? iscolour?.Colour6
                          : iscolourDark?.Colour10
                      }`,
                      borderRadius: "12px",
                      width: "100%",
                      padding: "25px",
                      height: "100px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "700",
                          minWidth: "95px",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour5
                              : iscolourDark?.Colour12,
                          letterSpacing: "2px",
                        }}
                      >
                        BALANCE :
                      </span>

                      <span
                        style={{
                          fontSize: "26px",
                          fontWeight: "800",
                          textAlign: "center",
                          flex: 1,
                          color:
                            isdark === "light"
                              ? iscolour?.Colour12
                              : iscolourDark?.Colour12,
                          lineHeight: "1.2",
                        }}
                      >
                        {formatIndianAmount(
                          Ledgersummarydata?.LedgerSumm?.[0]?.Balance || 0,
                        )}
                      </span>

                      <div style={{ minWidth: "95px" }}></div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>

        <Col xs={12}>
          <div style={{ marginTop: "20px" }}>
            <div
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour4,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  padding: "14px",
                  margin: 0,
                }}
              >
                <h2
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    letterSpacing: "1px",
                    fontWeight: "600",
                  }}
                >
                  SUMMARY
                </h2>
              </div>
              <FASTable data={getRows} columns={getColumns} />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
